const Footer = () => {
  return (
    <footer className="py-12 px-6 border-t border-slate-200 dark:border-slate-800 text-center">
      <div className="max-w-7xl mx-auto">
        <p className="text-slate-500 dark:text-slate-400">© 2026 Sunil Kublalsingh. Built with passion &amp; coffee.</p>
      </div>
    </footer>
  );
};

export default Footer;
